import { CiLogout } from "react-icons/ci"; 
import { RiLogoutBoxLine } from "react-icons/ri"; 
import { FiLogOut } from "react-icons/fi"; 
import { SlLogout } from "react-icons/sl"; 
import { RiLogoutCircleLine } from "react-icons/ri"; 
import { BiLogOutCircle } from "react-icons/bi"; 
import { BsFillClipboardPlusFill } from "react-icons/bs"; 
import { MdOutlineLocalPostOffice } from "react-icons/md"; 
import { RiMessage2Line } from "react-icons/ri"; 
import { MdOutlinePayment } from "react-icons/md"; 
import { AiFillSetting } from "react-icons/ai"; 
import { FcSettings } from "react-icons/fc"; 
import { RiSecurePaymentLine } from "react-icons/ri"; 
import { RiSecurePaymentFill } from "react-icons/ri"; 
import { AiOutlineTransaction } from "react-icons/ai"; 
import { MdPayments } from "react-icons/md"; 
import { HiOutlineDocumentReport } from "react-icons/hi"; 
import { ImUsers } from "react-icons/im"; 
import { FaBriefcase } from "react-icons/fa";
import { FaMoneyBillWave } from "react-icons/fa";
import { HiMenu, HiX } from "react-icons/hi";
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import UserManagement from './admin/UserManagement';
import InquiryList from './admin/InquiryList';
// import MassEmailDistribution from './admin/MassEmailDistribution';
// import MemberStatusChange from './admin/MemberStatusChange';
// import PaymentManagement from './admin/PaymentManagement';
import PaymentTransactionManagement from './admin/PaymentTransactionManagement';
import PaymentSettingsManagement from './admin/PaymentSettingsManagement';
import PointCostManagement from './admin/PointCostManagement';
import SentMessages from './admin/SentMessages';
import InboxMessages from './admin/InboxMessages';
import EmailManagement from './admin/EmailManagement';
import BoardPostsManagement from './admin/BoardPostsManagement';
import AnnualIncomeManagement from './admin/AnnualIncomeManagement';
import OccupationManagement from './admin/OccupationManagement';
import AdminProfileSettings from './admin/AdminProfileSettings';
import PaymentHistoryManagement from './admin/PaymentHistoryManagement';

const AdminPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeSection, setActiveSection] = useState('user-management');
  const [messageMenuOpen, setMessageMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  useEffect(() => {
    const updateDimensions = () => {
      const newIsMobile = window.innerWidth < 768;
      setIsMobile(newIsMobile);
      
      // Auto-hide sidebar on mobile when screen size changes to mobile
      if (newIsMobile && !isSidebarCollapsed) {
        setIsSidebarCollapsed(true);
      }
    };

    // Set initial mobile state and auto-hide sidebar on mobile
    const initialIsMobile = window.innerWidth < 768;
    setIsMobile(initialIsMobile);
    if (initialIsMobile) {
      setIsSidebarCollapsed(true);
    }

    window.addEventListener('resize', updateDimensions);
    return () => window.removeEventListener('resize', updateDimensions);
  }, []);

  // Sync activeSection with current URL
  useEffect(() => {
    const path = location.pathname;
    if (path === '/admin' || path === '/admin/user-management') {
      setActiveSection('user-management');
    } else if (path === '/admin/inquiry-list') {
      setActiveSection('inquiry-list');
    } else if (path === '/admin/payment-transactions') {
      setActiveSection('payment-transactions');
    } else if (path === '/admin/payment-settings') {
      setActiveSection('payment-settings');
    } else if (path === '/admin/point-costs') {
      setActiveSection('point-costs');
    } else if (path === '/admin/sent-messages') {
      setActiveSection('sent-messages');
    } else if (path === '/admin/inbox-messages') {
      setActiveSection('inbox-messages');
    } else if (path === '/admin/board-posts') {
      setActiveSection('board-posts');
    } else if (path === '/admin/annual-income') {
      setActiveSection('annual-income');
    } else if (path === '/admin/occupation-management') {
      setActiveSection('occupation-management');
    } else if (path === '/admin/email-management') {
      setActiveSection('email-management');
    } else if (path === '/admin/profile-settings') {
      setActiveSection('profile-settings');
    } else if (path === '/admin/payment-history') {
      setActiveSection('payment-history');
    }
  }, [location.pathname]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    // console.log("=======",localStorage);
    navigate('/login');
  };

  const handleLegalPage = (page) => {
    switch (page) {
      case 'age-verification':
        navigate('/legal/age-verification');
        break;
      case 'terms':
        navigate('/legal/terms-of-service');
        break;
      case 'transactions':
        navigate('/legal/transaction-law');
        break;
      case 'privacy':
        navigate('/legal/privacy-policy');
        break;
      default:
        navigate('/legal/age-verification');
    }
  };

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  const handleNavigationClick = (section) => {
    // Auto-hide sidebar on mobile when navigation item is clicked
    if (isMobile) {
      setIsSidebarCollapsed(true);
    }
    
    // Navigate to the appropriate URL
    switch (section) {
      case 'user-management':
        navigate('/admin/user-management');
        break;
      case 'inquiry-list':
        navigate('/admin/inquiry-list');
        break;
      case 'payment-transactions':
        navigate('/admin/payment-transactions');
        break;
      case 'payment-settings':
        navigate('/admin/payment-settings');
        break;
      case 'point-costs':
        navigate('/admin/point-costs');
        break;
      case 'sent-messages':
        navigate('/admin/sent-messages');
        break;
      case 'inbox-messages':
        navigate('/admin/inbox-messages');
        break;
      case 'board-posts':
        navigate('/admin/board-posts');
        break;
      case 'annual-income':
        navigate('/admin/annual-income');
        break;
      case 'occupation-management':
        navigate('/admin/occupation-management');
        break;
      case 'profile-settings':
        navigate('/admin/profile-settings');
        break;
      case 'email-management':
        navigate('/admin/email-management');
        break;
      case 'payment-history':
        navigate('/admin/payment-history');
        break;
      default:
        navigate('/admin/user-management');
    }
  };

  const menuItems = [
    { id: 'user-management', label: 'ユーザー管理', icon: <ImUsers /> },
    { id: 'inquiry-list', label: 'お問い合わせ一覧', icon: <HiOutlineDocumentReport /> },
    // { id: 'mass-email', label: '一括メール配信', icon: '📨' },
    // { id: 'member-status', label: '会員ステータス変更', icon: '⚙️' },
    // { id: 'payment-management', label: '入金管理', icon: <MdPayments /> },
    // { id: 'payment-transactions', label: '取引管理', icon: <AiOutlineTransaction />},
    // { id: 'payment-settings', label: '支払い設定', icon: <AiFillSetting />},
    // { id: 'point-costs', label: 'ポイントコスト管理', icon: <MdOutlinePayment /> },
    // { id: 'occupation-management', label: '職業管理', icon: <FaBriefcase /> },
    // { id: 'annual-income', label: '年収管理', icon: <FaMoneyBillWave /> },
    { id: 'message-management', label: 'メッセージ管理', icon: <RiMessage2Line />, isParent: true },
    { id: 'board-posts', label: '掲示板管理', icon: <BsFillClipboardPlusFill /> },
    { id: 'payment-history', label: '入金履歴管理', icon: <MdPayments /> },
    { id: 'profile-settings', label: '管理者プロフィール', icon: <AiFillSetting /> }
  ];

  const renderContent = () => {
    switch (activeSection) {
      case 'user-management':
        return <UserManagement />;
      case 'inquiry-list':
        return <InquiryList />;
      // case 'mass-email':
      //   return <MassEmailDistribution />;
      // case 'member-status':
      //   return <MemberStatusChange />;
      // case 'payment-management':
      //   return <PaymentManagement />;
      case 'payment-transactions':
        return <PaymentTransactionManagement />;
      case 'payment-settings':
        return <PaymentSettingsManagement />;
      case 'point-costs':
        return <PointCostManagement />;
      case 'occupation-management':
        return <OccupationManagement />;
      case 'annual-income':
        return <AnnualIncomeManagement />;
      case 'sent-messages':
        return <SentMessages />;
      case 'inbox-messages':
        return <InboxMessages />;
      case 'email-management':
        return <EmailManagement />;
      case 'board-posts':
        return <BoardPostsManagement />;
      case 'payment-history':
        return <PaymentHistoryManagement />;
      case 'profile-settings':
        return <AdminProfileSettings />;
      default:
        return <UserManagement />;
    }
  };

  return (
    <div style={{ 
      display: 'flex', 
      minHeight: '100vh',
      backgroundColor: '#f5f5f5',
      flexDirection: isMobile ? 'column' : 'row'
    }}>
      {/* Left Margin (200px) - Hidden on mobile */}
      {!isMobile && <div style={{ width: '200px', backgroundColor: '#f5f5f5' }}></div>}

      {/* Main Content Area */}
      <div style={{
        flex: 1,
        display: 'flex',
        maxWidth: isMobile ? '100%' : '95%',
        margin: '0 auto',
        flexDirection: isMobile ? 'column' : 'row'
      }}>
        {/* Sidebar */}
        <div style={{
          width: isMobile ? (isSidebarCollapsed ? '0px' : '100%') : '250px',
          backgroundColor: '#2c3e50',
          color: 'white',
          padding: isMobile ? (isSidebarCollapsed ? '0px' : '20px 0') : '20px 0',
          boxShadow: '2px 0 5px rgba(0,0,0,0.1)',
          overflow: isMobile && isSidebarCollapsed ? 'hidden' : 'visible',
          transition: 'all 0.3s ease',
          display: isMobile && isSidebarCollapsed ? 'none' : 'block'
        }}>
          {/* Header */}
          <div style={{
            padding: '0 20px 20px 20px',
            borderBottom: '1px solid #34495e',
            marginBottom: '20px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <div>
                          <div style={{
              backgroundColor: '#ffd700',
              padding: isMobile ? '8px 12px' : '10px 15px',
              borderRadius: '5px',
              display: 'inline-block'
            }}>
              <h1 style={{ 
                color: 'white', 
                margin: 0, 
                fontSize: isMobile ? '16px' : '20px' 
              }}>STYLE</h1>
            </div>
            <p style={{ 
              margin: '10px 0 0 0', 
              fontSize: isMobile ? '11px' : '14px', 
              color: '#bdc3c7' 
            }}>
              管理者パネル
            </p>
            </div>
            {isMobile && (
              <button
                onClick={toggleSidebar}
                style={{
                  backgroundColor: 'transparent',
                  border: 'none',
                  fontSize: '24px',
                  cursor: 'pointer',
                  color: 'white',
                  padding: '5px',
                  borderRadius: '5px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <HiX />
              </button>
            )}
          </div>

          {/* Menu Items */}
          <div>
            {menuItems.map((item) => (
              item.isParent ? (
                <div key={item.id}>
                  <div
                    onClick={() => setMessageMenuOpen((open) => !open)}
                    style={{
                      padding: '15px 20px',
                      cursor: 'pointer',
                      backgroundColor: activeSection.startsWith('sent-messages') || activeSection.startsWith('inbox-messages') ? '#3498db' : 'transparent',
                      borderLeft: (activeSection.startsWith('sent-messages') || activeSection.startsWith('inbox-messages')) ? '4px solid #ffd700' : '4px solid transparent',
                      transition: 'all 0.3s ease',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between'
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <span style={{ fontSize: '18px', marginRight: '10px' }}>{item.icon}</span>
                      <span style={{ fontSize: '14px' }}>{item.label}</span>
                    </div>
                    <span style={{ fontSize: '14px' }}>{messageMenuOpen ? '▲' : '▼'}</span>
                  </div>
                  {messageMenuOpen && (
                    <div style={{ marginLeft: '30px', background: 'rgba(255,255,255,0.03)' }}>
                      <div
                        onClick={() => handleNavigationClick('sent-messages')}
                        style={{
                          padding: '10px 0',
                          cursor: 'pointer',
                          color: activeSection === 'sent-messages' ? '#ffd700' : 'white',
                          fontWeight: activeSection === 'sent-messages' ? 'bold' : 'normal'
                        }}
                      >
                        送信済みメッセージ
                      </div>
                      <div
                        onClick={() => handleNavigationClick('inbox-messages')}
                        style={{
                          padding: '10px 0',
                          cursor: 'pointer',
                          color: activeSection === 'inbox-messages' ? '#ffd700' : 'white',
                          fontWeight: activeSection === 'inbox-messages' ? 'bold' : 'normal'
                        }}
                      >
                        受信メッセージ
                      </div>
                      <div
                        onClick={() => handleNavigationClick('email-management')}
                        style={{
                          padding: '10px 0',
                          cursor: 'pointer',
                          color: activeSection === 'email-management' ? '#ffd700' : 'white',
                          fontWeight: activeSection === 'email-management' ? 'bold' : 'normal'
                        }}
                      >
                        メール管理
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div
                  key={item.id}
                  onClick={() => handleNavigationClick(item.id)}
                  style={{
                    padding: isMobile ? '12px 16px' : '15px 20px',
                    cursor: 'pointer',
                    backgroundColor: activeSection === item.id ? '#3498db' : 'transparent',
                    borderLeft: activeSection === item.id ? '4px solid #ffd700' : '4px solid transparent',
                    transition: 'all 0.3s ease'
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ 
                      fontSize: isMobile ? '16px' : '18px', 
                      marginRight: '10px' 
                    }}>{item.icon}</span>
                    <span style={{ 
                      fontSize: isMobile ? '12px' : '14px' 
                    }}>{item.label}</span>
                  </div>
                </div>
              )
            ))}
          </div>

          
        </div>
        
        {/* Main Content */}
        
        <div style={{
          flex: 1,
          padding: '20px',
          overflow: 'auto',
          width: isMobile && isSidebarCollapsed ? '100%' : 'auto'
        }}>
          
          <div style={{
            backgroundColor: 'white',
            borderRadius: '10px',
            padding: '30px',
            paddingBottom: '90px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
            minHeight: 'calc(100vh - 40px)'
          }}>
            <div style={{display:'flex', flexDirection:'column', }}>
              <div style={{marginBottom:'10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                {/* Hamburger Menu Button - Only show on mobile when sidebar is collapsed */}
                {isMobile && isSidebarCollapsed && (
                  <button
                    onClick={toggleSidebar}
                    style={{
                      backgroundColor: 'transparent',
                      border: 'none',
                      fontSize: '24px',
                      cursor: 'pointer',
                      color: '#333',
                      padding: '5px',
                      borderRadius: '5px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <HiMenu />
                  </button>
                )}
                
                {/* Logout Button */}
                <div style={{
                  marginLeft: 'auto'
                  // position: 'absolute',
                  // bottom: '20px',
                  // // left: '250px',
                  // right: '20px'
                }}>
                  <button
                    onClick={handleLogout}
                    style={{
                      width: '150px',
                      backgroundColor: '#e74c3c',
                      color: 'white',
                      border: 'none',
                      padding: '12px',
                      borderRadius: '5px',
                      cursor: 'pointer',
                      justifyContent: 'center',
                      alignItems: 'center',
                      fontSize: '14px'
                    }}
                  >
                    ログアウト
                    
                  </button>
                  {/* <RiLogoutBoxLine style={{marginLeft:'-140px'}}/> */}
                </div>
              </div>
              <div style={{width:'100%', height:'5px', backgroundColor:'orange' ,marginBottom:'10px'}}></div>
            </div>
            {renderContent()}
          </div>
        </div>
      </div>

      {/* Right Margin (200px) */}
      <div style={{ width: '200px', backgroundColor: '#f5f5f5' }}></div>

      {/* Footer */}
      <footer style={{
        height: "66px", 
        width: '100%', 
        fontSize: '13px', 
        backgroundColor: 'rgba(44, 41, 41, 0.95)',
        display: 'flex',
        
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backdropFilter: 'blur(10px)',
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000
      }}>
        <div style={{
          marginBottom: '8px'
        }}>
          {/* <a 
            onClick={() => handleLegalPage('age-verification')}
            style={{
              color: '#bdb7b7',
              cursor: 'pointer',
              textDecoration: 'none',
              margin: '0 10px',
              transition: 'color 0.3s ease'
            }}
            onMouseEnter={(e) => e.target.style.color = '#ffd700'}
            onMouseLeave={(e) => e.target.style.color = '#bdb7b7'}
          >
            年齢認証に関して
          </a>
          <span style={{ color: '#777676' }}>|</span> */}
          <a 
            onClick={() => handleLegalPage('terms')}
            style={{
              color: '#bdb7b7',
              cursor: 'pointer',
              textDecoration: 'none',
              margin: '0 10px',
              transition: 'color 0.3s ease'
            }}
            onMouseEnter={(e) => e.target.style.color = '#ffd700'}
            onMouseLeave={(e) => e.target.style.color = '#bdb7b7'}
          >
            利用規約
          </a>
          <span style={{ color: '#777676' }}>|</span>
          <a 
            onClick={() => handleLegalPage('transactions')}
            style={{
              color: '#bdb7b7',
              cursor: 'pointer',
              textDecoration: 'none',
              margin: '0 10px',
              transition: 'color 0.3s ease'
            }}
            onMouseEnter={(e) => e.target.style.color = '#ffd700'}
            onMouseLeave={(e) => e.target.style.color = '#bdb7b7'}
          >
            特定商取引法に基く表記
          </a>
          <span style={{ color: '#777676' }}>|</span>
          <a 
            onClick={() => handleLegalPage('privacy')}
            style={{
              color: '#bdb7b7',
              cursor: 'pointer',
              textDecoration: 'none',
              margin: '0 10px',
              transition: 'color 0.3s ease'
            }}
            onMouseEnter={(e) => e.target.style.color = '#ffd700'}
            onMouseLeave={(e) => e.target.style.color = '#bdb7b7'}
          >
            プライバシーポリシー
          </a>
        </div>
        <div style={{
          color: '#747272',
          fontSize: '12px'
        }}> 
          Copyright © 2025 スタート. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default AdminPage; 